import { CTAPIConfiguration } from './utils/configuration';
import { RequestHelper } from './utils/request';
import { AccountRestInterface } from './interfaces/_account.rest';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export class AccountRest implements AccountRestInterface {

    private configuration: CTAPIConfiguration;
    private requestHelper: RequestHelper;

    constructor(configuration: CTAPIConfiguration) {
        this.configuration = configuration;
        this.requestHelper = new RequestHelper(configuration);
    }

    /**
     * Request to notify new account creation.
     */
    notifyAccountCreation(configId: string, email: string, nDivID: number, uuid: string): Observable<any> {
        return this.requestHelper.request({ data: { nDivID, portalConfigName: configId, accountEmailAddress: email, uuid } },
            this.configuration.account.notifyNewAccount, this.configuration.httpClient
        ).pipe(
            map((response) => {
                return response;
            })
        );
    }

}
